import * as React from "react"

const CommentSVG = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" width={18} height={17} fill="none" {...props}>
		<path
			fill="#475163"
			d="M12.333 3c.467 0 .834.367.834.833a.825.825 0 0 1-.834.834.825.825 0 0 1-.833-.834c0-.466.367-.833.833-.833Zm0-2.5c2.275 0 4.217 1.383 5 3.333-.783 1.95-2.725 3.334-5 3.334s-4.216-1.384-5-3.334c.784-1.95 2.725-3.333 5-3.333Zm0 1.25a2.083 2.083 0 1 0 0 4.167 2.083 2.083 0 0 0 0-4.167ZM14 8.625v2.708H9.9L7.333 13.9v-2.567h-5V3h3.559a6.95 6.95 0 0 1 1.025-1.667H2.333A1.667 1.667 0 0 0 .667 3v8.333A1.666 1.666 0 0 0 2.333 13h3.334v2.5a.833.833 0 0 0 .833.833h.417a.85.85 0 0 0 .583-.241L10.583 13H14a1.66 1.66 0 0 0 1.667-1.667V8A7.295 7.295 0 0 1 14 8.625Z"
		/>
	</svg>
)

export default CommentSVG
